module.exports = __webpack_public_path__ + "img/electricMotorcycle-dark-grey.3dfe9371.svg";